export const MATERIAL_PRESETS = [
  {
    id: "mdf-18",
    i18nKey: "mdf18",
    defaultThickness: 18,
    allowRotation: true,
  },
  {
    id: "mdf-15",
    i18nKey: "mdf15",
    defaultThickness: 15,
    allowRotation: true,
  },
  {
    id: "mdf-12",
    i18nKey: "mdf12",
    defaultThickness: 12,
    allowRotation: true,
  },
  {
    id: "mdf-9",
    i18nKey: "mdf9",
    defaultThickness: 9,
    allowRotation: true,
  },
  {
    id: "multiplex-18",
    i18nKey: "multiplex18",
    defaultThickness: 18,
    grainFixed: true,
  },
  {
    id: "multiplex-15",
    i18nKey: "multiplex15",
    defaultThickness: 15,
    grainFixed: true,
  },
  {
    id: "multiplex-12",
    i18nKey: "multiplex12",
    defaultThickness: 12,
    grainFixed: true,
  },
  {
    id: "multiplex-9",
    i18nKey: "multiplex9",
    defaultThickness: 9,
    grainFixed: true,
  },
  {
    id: "spaan-18",
    i18nKey: "spaan18",
    defaultThickness: 18,
    allowRotation: true,
  },
  {
    id: "spaan-15",
    i18nKey: "spaan15",
    defaultThickness: 15,
    allowRotation: true,
  },
  {
    id: "spaan-12",
    i18nKey: "spaan12",
    defaultThickness: 12,
    allowRotation: true,
  },
  {
    id: "meubelpaneel-18",
    i18nKey: "meubelpaneel18",
    defaultThickness: 18,
    allowRotation: true,
  },
];

export const PRIMARY_MATERIAL_PRESET_IDS = ["mdf-18", "mdf-15", "multiplex-18", "spaan-18"];

export function getPrimaryMaterialPresets() {
  return MATERIAL_PRESETS.filter((preset) => PRIMARY_MATERIAL_PRESET_IDS.includes(preset.id));
}

export function getMoreMaterialPresets() {
  return MATERIAL_PRESETS.filter((preset) => !PRIMARY_MATERIAL_PRESET_IDS.includes(preset.id));
}

export function isActiveMaterialPreset(project, preset, materialName) {
  return project.materialName === materialName
    && Number(project.sourcePanel.defaultThickness) === preset.defaultThickness;
}

export function presetChipName(label) {
  return label
    .replace(/\s+\d+(?:[.,]\d+)?\s*mm$/i, "")
    .replace(/\s+\d+$/i, "")
    .trim();
}

export function resolveMaterialPreset(preset, display) {
  const base = `web.presets.material.${preset.i18nKey}`;
  const hintKey = `${base}.hint`;
  const hintLookup = display.t(hintKey);
  const baseLabel = display.t(`${base}.label`);
  return {
    ...preset,
    label: `${presetChipName(baseLabel)} ${display.formatThickness(preset.defaultThickness)}`.trim(),
    hint: hintLookup !== hintKey ? hintLookup : undefined,
    materialName: display.t(`${base}.materialName`),
  };
}
